import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { trTR } from '@clerk/localizations';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { initSentry } from './lib/sentry';
import { initAnalytics } from './lib/analytics';
import { CLERK_PUBLISHABLE_KEY, isAuthEnabled } from './lib/auth';
import './index.css';

initSentry();
initAnalytics();

if (!isAuthEnabled) {
  // Uygulama cokmez; auth'a bagli UI "cikis yapmis" moduna duser.
  console.warn(
    'VITE_CLERK_PUBLISHABLE_KEY tanımlı değil. Kimlik doğrulama devre dışı, ' +
      'herkese açık sayfalar çalışmaya devam edecek.',
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1, refetchOnWindowFocus: false },
  },
});

const tree = (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {isAuthEnabled ? (
      <ClerkProvider
        publishableKey={CLERK_PUBLISHABLE_KEY!}
        localization={trTR}
        afterSignOutUrl="/"
        appearance={{
          variables: { colorPrimary: '#1447e1', borderRadius: '0.5rem' },
        }}
      >
        {tree}
      </ClerkProvider>
    ) : (
      tree
    )}
  </React.StrictMode>,
);
